import { render, staticRenderFns } from "./ViewPaymentPurpose.vue?vue&type=template&id=9a0b195c"
import script from "./ViewPaymentPurpose.vue?vue&type=script&lang=js"
export * from "./ViewPaymentPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports